import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LangContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success(t("login") + " ✓");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="text-xs text-[#8FA3BD] mb-6 inline-block hover:text-[#00E5FF]" data-testid="back-home-link">
          ← {t("backToHome")}
        </Link>
        <div className="bento-card p-8 animate-fade-up">
          <h1 className="text-3xl font-bold mb-2 text-cyan-gradient">{t("login")}</h1>
          <p className="text-sm text-[#8FA3BD] mb-8">{t("appName")}</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-[#8FA3BD] text-xs">{t("email")}</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="bg-[#050E1A] border-[#1A2D4D] text-white mt-1.5" data-testid="login-email-input" />
            </div>
            <div>
              <Label className="text-[#8FA3BD] text-xs">{t("password")}</Label>
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="bg-[#050E1A] border-[#1A2D4D] text-white mt-1.5" data-testid="login-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="btn-cyan w-full mt-2" data-testid="login-submit-btn">
              {loading ? "..." : t("submit")}
            </Button>
          </form>

          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-[#1A2D4D]" /></div>
            <div className="relative flex justify-center text-xs"><span className="bg-[#0F1F35] px-3 text-[#4A5970]">{t("or")}</span></div>
          </div>

          <Button onClick={handleGoogle} variant="outline" className="w-full border-[#1A2D4D] text-white hover:bg-[#1A2D4D]" data-testid="google-login-btn">
            <svg className="w-4 h-4 me-2" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            {t("continueGoogle")}
          </Button>

          <p className="text-center text-xs text-[#8FA3BD] mt-6">
            <Link to="/register" className="text-[#00E5FF]" data-testid="goto-register-link">{t("register")}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
